module.exports = {"applyButtonText":"Besjoch abonneminten","defaultPlaceholder":"Meitsje in kar"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/fy/product-filter.json
// module id = OBph
// module chunks = 1